import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-analyticstwittersummary',
  templateUrl: './analyticstwittersummary.component.html',
  styleUrls: ['./analyticstwittersummary.component.css']
})
export class AnalyticstwittersummaryComponent implements OnInit {
  @Input('details') details: any;
  @Input('analytics') analytics: any;

  constructor() {
  }

  ngOnInit() {

  }

}
